// Module
var code = "<div class=\"loading\" v-if=\"!isNoLoading && (isLoading || isForceLoading)\"> <div class=\"loading-bg\"></div> <img :src=\"'/img/loading.gif'\" alt=\"Loading...\"/> </div>";
// Exports
export default code;